// sensei-app/client/widgets/ChildsCourseProgressWidget.widget.js
export default {
    name: "ChildsCourseProgressWidget",
    type: "DataWidget",
    description: "Shows progress for the parent's child in all enrolled courses.",
    roles: ["parent"], // This widget is for Parents
    widget: {
        title: "Child's Course Progress",
        size: "large",

        dataProvider: {
            main: {
                rpc: "ParentRpc.getChildsCourseProgress",
                // This RPC returns { data: [...] }, so we extract the array.
                transform: (response) => response?.data || []
            }
        },
        
        viewMode: "list", // Set viewMode to list to allow itemTemplate to control layout fully

        // Use a custom item template for a better visual representation
        itemTemplate: (item) => {
            const progress = item.progress;
            if (!progress) {
                return `
                    <div class="list-group-item">
                        <strong>${item.title}</strong><br>
                        <span class="badge bg-secondary">Not Started</span>
                    </div>`;
            }
            
            const totalMarks = (item.topics || []).filter(t => t.isMandatory).reduce((sum, t) => sum + (t.marks || 0), 0);
            const percentage = totalMarks > 0 ? Math.round((progress.totalScore / totalMarks) * 100) : 0;
            const statusClass = progress.hasPassed ? 'bg-success' : 'bg-info';
            const statusText = progress.hasPassed ? 'Passed' : progress.isCompleted ? 'Completed' : 'In Progress';

            return `
                 <div class="list-group-item">
                    <div class="d-flex w-100 justify-content-between">
                        <h6 class="mb-1">${item.title}</h6>
                        <small>${progress.totalScore} / ${totalMarks} Marks</small>
                    </div>
                    <div class="progress" role="progressbar" style="height: 10px;">
                        <div class="progress-bar ${statusClass}" style="width: ${percentage}%"></div>
                    </div>
                    <small class="text-muted">${statusText}</small>
                </div>
            `;
        },
        noDataMessage: "Student is not enrolled in any courses."
    }
};